import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../enums/HttpStatusCodes';
import { CRECE_MAS_ENDPOINTS, NativeStorageNamesV2 } from '../models/Constants';
import { SharedServiceService } from './shared-service.service';
import { StorageData } from './utilities/storage-data.class';

@Injectable({
  providedIn: 'root'
})
export class CreceMasService {

  private storageGrowMore = NativeStorageNamesV2.GrowMore
  private actualToken = ''

  constructor(private sharedService: SharedServiceService) { }

  public async cerrarSesionCreceMas() {
    this.getTokenStorage()
  }

  private getTokenStorage = async () => {
    const tokenCrece = await StorageData.getDataStorage(this.storageGrowMore);
    if (tokenCrece) {
      this.actualToken = tokenCrece.token
      this.sharedService.executeRequestByUser(CRECE_MAS_ENDPOINTS.post_cerrar_sesion,
        { token: this.actualToken }, this.sharedService.getAzureCAUrl(AZURE_CA_URLS.INTEGRACIONES))
        .pipe(take(1))
        .subscribe(() => { });
      await StorageData.removeDataStorage(this.storageGrowMore);
    }
  }

}
